import MatriculasIndexPage from "@/Pages/Matriculas/index.vue";
import NewEditMatriculaPage from "@/Pages/Matriculas/NewEditMatriculaPage.vue";
import DesempenhoNotaAluno from "@/Pages/Matriculas/DesempenhoNotaAluno.vue";

export default [
  {
    path: "/matriculas/",
    name: "matriculas",
    component: MatriculasIndexPage,
  },
  {
    path: "/matriculas/create",
    name: "matriculas.create",
    component: NewEditMatriculaPage,
    props: { editing: false },
  },
  {
    path: "/matriculas/edit/:matricula_id",
    name: "matriculas.edit",
    component: NewEditMatriculaPage,
    props: { editing: true },
  },
  {
    path: "/matriculas/desempenho-de-notas-do-aluno/matricula/:matricula_id",
    name: "matriculas.desempenhoNota",
    component: DesempenhoNotaAluno,
    props: { editing: true },
  },
];
